import type { ConfirmMessage } from '@/models/ConfirmMessage';

export const NO_ACCESSIBLE_OUS_ERROR = 'NO_ACCESSIBLE_OUS';

export const NO_ACCESSIBLE_OUS_LOGOUT_MESSAGE =
  'You are being logged out because your account is not assigned to any accessible organizational units. Please contact support.';

export const NO_ACCESSIBLE_OUS_CONFIRM: ConfirmMessage = {
  title: 'Sign out',
  message: NO_ACCESSIBLE_OUS_LOGOUT_MESSAGE,
  confirmText: 'OK',
  cancelText: 'Cancel',
};

/** RTK .unwrap() rejects with a serialized error object, not always instanceof Error. */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const { message } = error as { message: unknown };
    return typeof message === 'string' ? message : String(message);
  }
  return String(error);
}

export function isNoAccessibleOUsError(error: unknown): boolean {
  return getErrorMessage(error) === NO_ACCESSIBLE_OUS_ERROR;
}
